import { useState } from "react";
import { Tag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { CreatorCodeInput } from "@/components/monetization/CreatorCodeInput";

/**
 * Small tappable link shown alongside every paywall CTA so users can enter
 * a creator code before starting their Apple free trial.
 */
export function CreatorCodeLink({ className = "" }: { className?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-primary underline-offset-4 hover:underline transition-colors ${className}`}
      >
        <Tag className="w-3.5 h-3.5" />
        Have a creator code?
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-2xl">
          <SheetHeader>
            <SheetTitle>Creator code</SheetTitle>
          </SheetHeader>
          <div className="pt-4 pb-6">
            <CreatorCodeInput />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
